// extracted by mini-css-extract-plugin
export default {"DisplayNewFeatureVersion":"DisplayNewFeatureVersion_DisplayNewFeatureVersion__2EB6f","subHeader":"DisplayNewFeatureVersion_subHeader__7rlko"};